/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import {browserHistory} from 'react-router'
import './Modal.scss'
import createPoster from 'controllers/poster/createPoster'
import createContent from 'controllers/poster/createContent';

class ModalContent extends React.Component {


  onCreatePoster(data){
    const schoolId = localStorage.getItem('schoolId')
    const {dismiss} = this.props

    let emptyPoster = {
      template: '',
      poster_type: '',
      title: '',
      state: '',
      show_spots_left: '',
      show_page_view: '',
    }

    let newPoster = {
      ...emptyPoster, 
      poster_type: data,
    }
    
    createPoster(schoolId, newPoster)
    .then((res) => {
      if(res.result == 'success') {
        const { poster_id } = res;

        //
        // The first element by default is a text
        //
        const firstContent = {
          index: 1,
          content_type: 'text',
          text: '',
        }
        createContent(poster_id, firstContent)
          .then((res)=>{
            browserHistory.push({pathname: `/edit-poster/${poster_id}`})
            dismiss()
          });
      }
    })
    .catch((err) => {console.log(err)})
  }

  render() {

    return (
      <div className='poster-type-content'>
        <div className='row'>
          <div className='col-xs-5 type-container text-center enabled' onClick={() => {this.onCreatePoster('basic')}}>
            <h2 className='type-title'>{__('Basic Poster', 'poster')}</h2>
            <p className='type-description'>{__('Create a poster that contains only texts and pictures', 'poster')}</p>
          </div>
          <div className='col-xs-5 type-container text-center' onClick={() => {this.onCreatePoster('registration')}}>
            <h2 className='type-title'>{__('Enrollment Registration', 'poster')}</h2>
            <p className='type-description'>{__('Create a poster that allows users to register for classes or events', 'poster')}</p>
          </div>
          <div className='col-xs-5 type-container-disable text-center disabled'>
            <h2 className='type-title'>{__('Event Registration', 'poster')}</h2>
            <p className='type-description'>{__('Create a poster that allows users to register tickets', 'poster')}</p>
          </div>
          <div className='col-xs-5 type-container-disable text-center disabled'>
            <h2 className='type-title'>{__('Survey', 'poster')}</h2>
            <p className='type-description'>{__('Create a poster that contains a survey or questionnaire', 'poster')}</p>
          </div>
        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/PosterType/ModalContent.js